export const pageTransitionDuration = 0.75;

export default {
  pageTransitionDuration,
};
